import { render, staticRenderFns } from "./ReturnTo.vue?vue&type=template&id=48698ee1"
import script from "./ReturnTo.vue?vue&type=script&lang=js"
export * from "./ReturnTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports